type EnvType = {
  CHECKPOINT_APP_ENVIRONMENT: string;
};

export const env: EnvType = { ...process.env, ...window.env };
